export function isTransientHttpStatus(status: number) {
  return status === 408 || status === 425 || status === 429 || status >= 500;
}

export function isTransientFailure(error: unknown, status?: number) {
  if (typeof status === 'number' && isTransientHttpStatus(status)) {
    return true;
  }
  if (error && typeof error === 'object' && 'name' in error && (error as { name?: string }).name === 'AbortError') {
    return true;
  }
  if (error instanceof TypeError) {
    return true;
  }
  return false;
}
